import {FC} from "react";
import {BlockToggleDescriptionTehnology} from "../../InfoExpand/blockToggleDescriptionTehnology";
import {
  apiKeyDataTehnology,
  urlApi,
  urlApiDataTehnology,
} from "../../../helper/api";
import {
  IClusterDataFromServer,
  IMetricsData,
  ITehnologiesDataFromServer,
  ITehnologyDataSideBar,
} from "../../../pages/Dashboard/Dashboard.type";
import {ITypeRadar} from "../../../types";
import {ExpertsInfoExpand, OrganizationInfoExpand} from "../../InfoExpand";
import ApplicationScenarios from "../../ApplicationScenarios";
import {OpenedDescriptionContent, Title} from "../stylesCases";
import {BlockCasesMap} from "../SidebarCardUI/BlockCasesMap";
import {BlockDescription} from "../SidebarCardUI/BlockDescription";
import {TitleBlockTrend} from "../SidebarCardUI/TitleBlockTrend";
import {TitleCard} from "../styles";
import useFetchDataTechTehnologyById from "../../../hooks/useFetchDataTechTehnology";
import {MarketScienceCharts} from "../SidebarCardUI/MarketScienceCharts/MarketScienceCharts";
import {MarketScienceChartPanel} from "../SidebarCardUI/MarketScienceCharts/MarketScienceChartPanel";
import {SideBarContentMapBattery} from "./SideBarContentMapBattery";

interface IProps {
  idMoleculeActive: number;
  dataCluster?: IClusterDataFromServer | undefined;
  clusterIdOnTehnologie?: number;
  dataTehnology: ITehnologiesDataFromServer | undefined;
  typeRadar: ITypeRadar;
  // dataCurrentMolecula: IClustersMolecule | undefined;
  colorTitle?: string;
  technologieId?: number | string | null;
  setIsShowCharts?: (value: boolean) => void;
  isShowCharts?: boolean;
}

export const SideBarContentMapTehnologie: FC<IProps> = ({
  dataTehnology: dataTechnology,
  typeRadar,
  // dataCurrentMolecula,
  colorTitle,
  technologieId,
  idMoleculeActive,
  dataCluster,
  clusterIdOnTehnologie,
  setIsShowCharts,
  isShowCharts,
}) => {
  // console.log("dataTeh0000000000000nology", technologieId);
  if (!apiKeyDataTehnology) {
    throw new Error("API key Карта технологий не тот");
  }
  const apiUrlTechTehnologie = `${urlApiDataTehnology}/api`;
  const {tehnologieData, citationList} = useFetchDataTechTehnologyById(
    apiUrlTechTehnologie,
    apiKeyDataTehnology,
    technologieId?.toString() || ""
  );
  const activeMolecule = citationList?.data?.find(
    (item) => item.id === idMoleculeActive
  );

  const activeCluster = activeMolecule?.clusters?.find(
    (item) =>
      item.cluster &&
      tehnologieData?.data.cluster &&
      item.cluster.documentId === tehnologieData?.data.cluster.documentId
  );

  const infoActiveTehnologie = activeCluster?.technologies.find(
    (item) =>
      tehnologieData?.data.cluster &&
      item.technology.documentId === tehnologieData?.data.documentId
  );

  let dataTehnology: ITehnologyDataSideBar | undefined = tehnologieData
    ? {
        id: tehnologieData.data.documentId,
        name: tehnologieData?.data?.name ?? "",
        cluster_name: tehnologieData?.data?.cluster?.name ?? "",
        desc: tehnologieData.data.desc ?? "",
        gpb: tehnologieData.data.gpb ?? false,
        growth_potential: tehnologieData.data.growth_potential ?? true,
        image: tehnologieData.data.image ?? "",
        invest_volume_tier: tehnologieData.data.invest_volume_tier || 0,
        potential_volume_tier: tehnologieData.data.potential_volume_tier || 0,
        trl: tehnologieData.data.trl_tier || 0,
        source: "",
        use_cases: tehnologieData.data.use_cases || [],
        metrics_data: tehnologieData.data.metrics_data,
        battery_russia: tehnologieData.data.battery_russia || "",
        battery_world: tehnologieData.data.battery_world || "",
      }
    : undefined;
  // const transformedDataTehnology: ITehnologyDataSideBar | undefined =
  //   dataTehnology
  //     ? {
  //         id: dataTehnology.id,
  //         name: dataTehnology.name,
  //         cluster_name: dataTehnology.cluster_name || "",
  //         desc: dataTehnology.desc || "",
  //         gpb: dataTehnology.gpb || false,
  //         growth_potential: dataTehnology.growth_potential || false,
  //         image: dataTehnology.image || "",
  //         invest_volume_tier: dataTehnology.invest_volume_tier || 0,
  //         potential_volume_tier: dataTehnology.potential_volume_tier || 0,
  //         trl: dataTehnology.trl || 0,
  //         // source:
  //         //   dataCurrentMolecula?.data.find(
  //         //     (item: any) => item.technology_id === dataTehnology?.id
  //         //   )?.source || "",
  //         use_cases: dataTehnology.use_cases || [],
  //       }
  //     : undefined;
  return (
    <>
      <TitleCard color={colorTitle}>
        {dataTehnology?.name || "Default Title"}
      </TitleCard>
      {!isShowCharts ? (
        <>
          <>
            <BlockDescription
              text={dataTehnology?.desc}
              image={
                dataTehnology?.image?.url &&
                `${urlApi}/cms/techradar${dataTehnology?.image?.url}`
              }
            />

            <SideBarContentMapBattery
              batteryRussia={dataTehnology?.battery_russia ?? ""}
              batteryWorld={dataTehnology?.battery_world ?? ""}
              type="tehnologie"
            />

            <MarketScienceCharts
              openCharts={() => setIsShowCharts && setIsShowCharts(true)}
            />
            <OpenedDescriptionContent>
              <Title>СЦЕНАРИИ ПРИМЕНЕНИЯ</Title>
              {dataTehnology?.use_cases.map((item: any, index) => {
                return (
                  <ApplicationScenarios
                    key={index}
                    text={item.use_case[0].children[0].text}
                  />
                );
              })}
            </OpenedDescriptionContent>
          </>
          {typeRadar === "molecula" &&
            infoActiveTehnologie?.citation &&
            infoActiveTehnologie.citationUrl && (
              <BlockToggleDescriptionTehnology
                data={infoActiveTehnologie?.citation}
                url={infoActiveTehnologie?.citationUrl}
                title={<TitleBlockTrend title="Кейс реализации продукта" />}
                typeRadar={typeRadar}
                isOpen
              />
            )}

          <OrganizationInfoExpand
            title="ОРГАНИЗАЦИИ"
            technologyName={`${dataTehnology?.name || ""} ${
              dataTehnology?.name || ""
            }`.trim()}
            isOpen={false}
          />
          <ExpertsInfoExpand title="ЭКСПЕРТЫ" isOpen={false} />
        </>
      ) : (
        <MarketScienceChartPanel
          dataCharts={dataTehnology?.metrics_data || ({} as IMetricsData)}
        />
      )}
    </>
  );
};
